import { Location, Route } from "vue-router";
import { UserWithAvatar } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import providers from "@/lib/api";
import { $t } from "@/lib/i18nHelpers";

export async function resolveUserIdByRoute(to: Route, from: Route, next: (v?: false | string | Location) => void) {
  const userId = Number(to.params.userId);
  if (isNaN(userId) || userId === 0) {
    const userName = to.params.username;
    const data = await providers.UserPublicDataProvider.search({ data: { usernames: [userName] } });
    const user = data.result.find(i => i.username === userName);
    if (user) {
      next({ ...to, name: to.name ?? undefined, params: { ...to.params, userId: user.id }, replace: true });
    } else {
      next({ name: "home", replace: true });
    }
    return;
  } else next();
}

export function resolveUserName(user?: UserWithAvatar | null): string {
  if (!user) return $t("User deleted");
  return user.disabled ? $t("{0} (inactive)", [user.screenName]) : user.screenName;
}
